import * as pricebannerListActions from 'action/pricebannerList'
import { normalizeConflictProductError } from 'action/pricebannerList'
import DetailedWarningModal from 'component/Modal/DetailedWarningModal'
import SuccessModal from 'component/Modal/SuccessModal'
import NewPagination from 'component/pagination/newPagination'
import DynamicsSelector from 'component/priceBanner/general/DynamicsSelector'
import ExclusionModalPriceBanner from 'component/priceBanner/general/ExclusionModalPriceBanner'
import PricebannerConfirmExitModal from 'component/priceBanner/general/PricebannerConfirmExitModal'
import PricebannerErrorModal from 'component/priceBanner/general/PricebannerErrorModal'
import PricebannerWarningModal from 'component/priceBanner/general/PricebannerWarningModal'
import { AddProductModal } from 'component/priceBanner/priceBannerProduct/AddProduct'
import InlineFilterProduct from 'component/priceBanner/priceBannerProduct/InlineFilterProduct'
import SideFilterProduct from 'component/priceBanner/priceBannerProduct/SideFilterProduct'
import TableProduct from 'component/priceBanner/priceBannerProduct/TableProduct'
import DownloadSVG from 'component/svgComponents/download'
import DropdownArrow from 'component/svgComponents/dropdownArrow'
import FilterSVG from 'component/svgComponents/filter'
import OneArrowLeft from 'component/svgComponents/oneArrowLeft'
import Col from 'component/utils/Col'
import ContentHeader from 'component/utils/ContentHeader'
import Row from 'component/utils/Row'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import SizeSelect, { components } from 'react-select'
import { bindActionCreators } from 'redux'
import { colourStyles } from 'utils/selectStyle'
import { filterBranchMapsForProductLms } from 'utils/priceBannerCsvWithStores'
import '../pictograms/pictograms.css'
import './styles.css'

const DEFAULT_PAGINATION = {
  hasPagination: true,
  page: 1,
  size: 10,
}

const DEFAULT_INITIAL_VALUES = {
  order: 'lm',
  orderDirection: "ASC",
  name: 'Todos',
  idBranches: [],
}

const EXTRA_SMALL_SCREEN = 768

const ALLOWED_PARAMS = [
  'listId',
  'dtStart',
  'dtEnd',
  'idBranches',
  'productLms',
  'themeCode',
  'listIds',
  'name'
];

const extractUrlParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const params = {};

  ALLOWED_PARAMS.forEach(param => {
    if (urlParams.has(param) && param !== 'productLms') {
      if (param === 'idBranches' || param === 'listIds') {
        const values = urlParams.getAll(param);
        if (values.length > 0) {
          params[param] = values;
        }
      } else {
        const value = urlParams.get(param);
        if (value && value.trim() !== '' && value !== 'undefined') {
          params[param] = value;
        }
      }
    }
  });

  return params;
};

const navigateWithParams = (params) => {
  const queryParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (key === 'productLms') return;
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value) && value.length > 0) {
        value.forEach(item => queryParams.append(key, item));
      } else if (!Array.isArray(value)) {
        queryParams.set(key, value);
      }
    }
  });

  const newUrl = `/pricebanner/list-products${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  browserHistory.push(newUrl);
};

const isPlaceholderFilter = (value) => {
  if (value === undefined || value === null) return true;
  const text = String(value).trim();
  return text === '' || text.toLowerCase() === 'todos';
};

/** Remove filtros de UI que não devem ir para a API (ex.: name "Todos" vira LIKE '%todos%' e zera o resultado). */
const cleanParam = (param) => {
  const cleaned = Object.fromEntries(
    Object.entries(param).filter(([key, value]) => key !== 'themeName' && value !== undefined && value !== 'undefined')
  );
  if (isPlaceholderFilter(cleaned.name)) {
    delete cleaned.name;
  }
  if (isPlaceholderFilter(cleaned.themeCode)) {
    delete cleaned.themeCode;
  }
  return cleaned;
};

/** Nome da lista para o ficheiro CSV: uma lista na tabela, filtro por nome, ou id da lista na URL. */
const deriveReportFileBaseName = (filters, displayProducts) => {
  const names = new Set()
    ; (displayProducts || []).forEach((p) => {
      const n = (p.listName || p.nameList || '').trim()
      if (n) names.add(n)
    })
  if (names.size === 1) {
    return [...names][0]
  }
  const filterName = filters?.name
  if (
    filterName &&
    typeof filterName === 'string' &&
    filterName.trim() &&
    filterName.trim().toLowerCase() !== 'todos'
  ) {
    return filterName.trim()
  }
  const listId = filters?.listId
  if (listId && String(listId).trim() && String(listId).toLowerCase() !== 'todos') {
    return `lista-${listId}`
  }
  return null
}

const updateUrlWithParams = (filters, replace = false) => {
  const urlParams = new URLSearchParams();

  Object.entries(filters || {}).forEach(([key, value]) => {
    if (key === 'productLms') return;
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value) && value.length > 0) {
        value.forEach(item => urlParams.append(key, item));
      } else if (!Array.isArray(value)) {
        urlParams.set(key, value);
      }
    }
  });

  const newUrl = `/pricebanner/list-products${urlParams.toString() ? `?${urlParams.toString()}` : ''}`;

  if (replace) {
    browserHistory.replace(newUrl);
  } else {
    browserHistory.push(newUrl);
  }
};

const PriceBannerProductContainer = ({
  auth: {
    user: { dsToken },
  },
  translate,
  find,
  deleteProductFromList,
  addProductsToList,
  clearPriceBannerList,
  downloadProductsReport,
  validateProducts,
  validateBranches,
  cancelValidation,
  list,
  metadata,
  auth,
}) => {
  const displayProducts = (() => {
    const seenListProductKeys = new Set()
    const allExpandedProducts = (list || []).flatMap(item => {
      const uniqueBranches = (item.branches || []).filter((branch, index, self) =>
        self.findIndex(b => b.idBranch === branch.idBranch) === index
      )
      const uniqueBranchNamesGrouped = (item.branchNamesGrouped || []).filter((name, index, self) =>
        self.indexOf(name) === index
      )
      const productLms = item.productLms || []
      const productDescriptions = item.productDescriptions || {}

      const expandedProducts = productLms.map((productLm, index) => {
        const productDescription = productDescriptions[productLm] || '-'
        const productIds = item.productIds || {}
        const productId = productIds[productLm] || null

        const mappedProduct = {
          cdProduct: `${item.idPriceBannerList || item.cdProduct || item.id}_${productLm}_${index}`,
          lm: productLm.lm || productLm.productLm || productLm.productCode || productLm,
          description: productDescription,
          listName: item.listName || item.nameList || item.name,
          themeName: item.themeName,
          themeCode: item.themeCode,
          idPriceBannerList: item.idPriceBannerList,
          branches: uniqueBranches,
          branchNamesGrouped: uniqueBranchNamesGrouped,
          cdPricebannerThemesList: item.idPriceBannerList || item.cdProduct,
          nameList: item.name,
          productLms,
          productCount: item.productCount || 0,
          originalProductLm: productLm,
          productId,
          productExtrasMap: item.productExtrasMap,
          cmpmExtra: item.productExtrasMap?.[productLm] ? { quantity: item.productExtrasMap[productLm].quantity, discountPercent: item.productExtrasMap[productLm].discountPercent } : undefined
        }
        return mappedProduct
      })
      return expandedProducts.filter((mappedProduct) => {
        const dedupeKey = `${mappedProduct.idPriceBannerList}_${mappedProduct.lm}`
        if (seenListProductKeys.has(dedupeKey)) {
          return false
        }
        seenListProductKeys.add(dedupeKey)
        return true
      })
    })
    return allExpandedProducts.sort((a, b) => {
      const lmA = a.lm || ''
      const lmB = b.lm || ''
      const lmComparison = lmA.localeCompare(lmB)
      if (lmComparison !== 0) {
        return lmComparison
      }
      const listNameA = a.listName || ''
      const listNameB = b.listName || ''
      return listNameA.localeCompare(listNameB)
    })
  })()

  const [isDownloading, setIsDownloading] = useState(false)
  const [openAddProductModal, setOpenAddProductModal] = useState(false)
  const [openSuccessModal, setOpenSuccessModal] = useState(false)
  const [order, setOrder] = useState({ order: 'lm', orderDirection: 'ASC' })
  const [lastTriedPayload, setLastTriedPayload] = useState(null)
  const [openWarningModal, setOpenWarningModal] = useState(false)
  const [showConfirmExitModal, setShowConfirmExitModal] = useState(false)
  const [emptyFilter, setEmptyFilter] = useState(true)
  const [openDeleteModal, setOpenDeleteModal] = useState({ show: false, selected: null })
  const [openErrorModal, setOpenErrorModal] = useState(false)
  const [optionSize, setOptionSize] = useState(10)
  const [cdDynamicList, setCdDynamicList] = useState([])
  const [selectedItemsData, setSelectedItemsData] = useState([])
  const [filters, setFilters] = useState()
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION)
  const [sideFilterElement, setSideFilterElement] = useState(null)
  const [sideFilterVisible, setSideFilterVisible] = useState(false)
  const [sideFilterWidth, setSideFilterWidth] = useState(0)
  const [errorDetails, setErrorDetails] = useState("Tempo Expirado")
  const [successMessage, setSuccessMessage] = useState('')
  const [inlineFilterVisible, setInlineFilterVisible] = useState(true)
  const [showTable, setShowTable] = useState(false)
  const [failedOperation, setFailedOperation] = useState(null)
  const [failedDeleteData, setFailedDeleteData] = useState(null)
  const [showProductsWarningModal, setShowProductsWarningModal] = useState(false)
  const [invalidProducts, setInvalidProducts] = useState([])
  const [showThemeWarningModal, setShowThemeWarningModal] = useState(false)
  const [themeWarningMessage, setThemeWarningMessage] = useState('')
  const [themeWarningType, setThemeWarningType] = useState('warning')
  const [themeWarningScrollableList, setThemeWarningScrollableList] = useState(null)
  const [pendingAddSuccess, setPendingAddSuccess] = useState(false)

  const headerRef = useRef(null)
  const filterRef = useRef(null)
  const tableRef = useRef(null)
  const forceCloseRef = useRef(false)
  const pendingEditExtrasSuccessRef = useRef(false)

  useEffect(() => {
    clearPriceBannerList();

    const urlParams = extractUrlParams();

    let invalidProductsFromStorage = [];
    try {
      const storedProducts = sessionStorage.getItem('priceBannerInvalidProducts');
      if (storedProducts) {
        invalidProductsFromStorage = JSON.parse(storedProducts);
        sessionStorage.removeItem('priceBannerInvalidProducts');
      }
    } catch (error) {
      // Ignore session storage errors
    }

    if (Object.keys(urlParams).length === 0 && invalidProductsFromStorage.length === 0) {
      setShowTable(false);
      return;
    }

    const initialFilters = { ...DEFAULT_INITIAL_VALUES };

    ALLOWED_PARAMS.forEach(key => {
      if (key in urlParams) {
        initialFilters[key] = urlParams[key];
      }
    });

    if (invalidProductsFromStorage.length > 0 && !initialFilters.productLms) {
      initialFilters.productLms = invalidProductsFromStorage;
    }

    setFilters(initialFilters);
    setShowTable(true);

    const param = {
      ...initialFilters,
      ...DEFAULT_PAGINATION,
      ...order,
      size: optionSize,
    };

    if (!param.listId && param.productLms && param.productLms.length > 0) {
      find(dsToken, cleanParam(param));
    } else if (param.listId) {
      find(dsToken, cleanParam(param));
    } else if (param.dtStart || param.dtEnd || param.idBranches) {
      find(dsToken, cleanParam(param));
    } else {
      setShowTable(false);
    }
  }, []);

  useEffect(() => {
    const handleUrlChange = () => {
      const urlParams = extractUrlParams();

      if (Object.keys(urlParams).length === 0) {
        setShowTable(false);
        return;
      }

      setFilters(prevFilters => {
        const newFilters = { ...DEFAULT_INITIAL_VALUES };
        ALLOWED_PARAMS.forEach(key => {
          if (key in urlParams) {
            newFilters[key] = urlParams[key];
          }
        });

        if (prevFilters?.productLms && !urlParams.productLms) {
          newFilters.productLms = prevFilters.productLms;
        }
        if (
          prevFilters?.themeName &&
          prevFilters?.themeCode &&
          newFilters.themeCode &&
          String(prevFilters.themeCode) === String(newFilters.themeCode)
        ) {
          // Keep selected label in UI state when URL sync runs.
          newFilters.themeName = prevFilters.themeName;
        }

        setShowTable(true);
        const param = {
          ...newFilters,
          ...DEFAULT_PAGINATION,
          ...order,
          size: optionSize,
        };

        find(dsToken, cleanParam(param));

        return newFilters;
      });
    };

    const unlisten = browserHistory.listen(handleUrlChange);

    return () => {
      unlisten();
    };
  }, [order, optionSize, dsToken]);

  useEffect(() => {
    if (!filters || !showTable || !hasData) return;

    const param = {
      ...filters,
      ...pagination,
      ...order,
      page: pagination.page,
      size: optionSize,
      idBranches: filters.idBranchesCodes ?? filters.idBranches ?? [],
    };

    find(dsToken, cleanParam(param));
  }, [pagination])

  useEffect(() => {
    const urlParams = extractUrlParams();
    const hasUrlParams = Object.keys(urlParams).length > 0;
    setInlineFilterVisible(!hasUrlParams);
  }, [window.location.search]);

  const handleResize = () => {
    const header = headerRef.current
    const filter = filterRef.current

    if (header && filter && window.innerWidth > EXTRA_SMALL_SCREEN) {
      const headerClientHeight = header.clientHeight
      filter.style.top = `${headerClientHeight}px`

      if (sideFilterVisible && sideFilterElement) {
        const newSideFilterWidth = sideFilterElement.clientWidth
        if (sideFilterWidth !== newSideFilterWidth) {
          setSideFilterWidth(newSideFilterWidth)
        }
      }
    }
  }

  const closeFilter = () => setSideFilterVisible(false)

  const resetFilters = () => {
    const resetFiltersValue = { ...DEFAULT_INITIAL_VALUES };
    setFilters(resetFiltersValue);
    setShowTable(false);

    browserHistory.push('/pricebanner/list-products');
  };

  const setValues = (values, isSearch = false) => {
    if (isSearch && values) {
      setEmptyFilter(false);
      const newFilters = { ...filters, name: values, page: 1, o: Math.random() };
      setFilters(newFilters);
      navigateWithParams(newFilters);
      return;
    }

    if (isSearch && !values) {
      delete filters.name;
      const newFilters = { ...filters, page: 1, o: Math.random() };
      setFilters(newFilters);
      setEmptyFilter(true);

      navigateWithParams(newFilters);
      return;
    }

    const cleanFilters = {
      ...DEFAULT_INITIAL_VALUES,
      page: 1,
      o: Math.random(),
    };

    if (values.idBranches && values.idBranches.length > 0) {
      cleanFilters.idBranches = values.idBranches;
    }

    if (values.themeCode && values.themeCode !== 'todos') {
      cleanFilters.themeCode = values.themeCode;
      if (values.themeName) {
        cleanFilters.themeName = values.themeName;
      }
    }

    if (values.listId && values.listId !== 'todos') {
      cleanFilters.listId = values.listId;
    }

    if (values.listIds && values.listIds.length > 0 && values.listIds[0] !== 'todos') {
      cleanFilters.listIds = values.listIds;
    }

    if (values.productLms && values.productLms.length > 0) {
      cleanFilters.productLms = values.productLms;
    }

    setFilters(cleanFilters);
    setShowTable(true);

    navigateWithParams(cleanFilters);

    const param = {
      ...DEFAULT_PAGINATION,
      ...cleanFilters,
      ...order,
      size: optionSize,
      idBranches: cleanFilters.idBranchesCodes ?? cleanFilters.idBranches ?? [],
    };

    delete param.idBranchesCodes;

    find(dsToken, cleanParam(param));
  };

  const handleDownloadReport = async () => {
    const hasProductsToDownload = (displayProducts ?? []).length > 0;
    if (!filters || !showTable || !hasProductsToDownload) return;
    setIsDownloading(true);
    try {
      const param = {
        ...filters,
        ...pagination,
        ...order,
        page: pagination.page,
        size: optionSize,
        idBranches: filters.idBranchesCodes ?? filters.idBranches ?? [],
      };
      delete param.idBranchesCodes;
      const reportFileBaseName = deriveReportFileBaseName(filters, displayProducts)
      await downloadProductsReport(
        dsToken,
        cleanParam({
          ...param,
          ...(reportFileBaseName ? { reportFileBaseName } : {}),
        })
      );
    } catch (e) {
      // Cancelamento explícito do usuário no modal: não exibir modal de erro.
      if (e?.cancelled || e?.name === 'AbortError') {
        return;
      }
      const msg = e?.message || translate('price.banner.error.generic');
      setErrorDetails(msg);
      setOpenErrorModal(true);
    } finally {
      setIsDownloading(false);
    }
  };

  const removeSelected = (cdParam) => {
    const hasSelected = cdDynamicList.includes(cdParam);
    if (hasSelected) {
      const newSelecteds = cdDynamicList.filter(param => param !== cdParam);
      const newSelectedData = selectedItemsData.filter(item => item.cdProduct !== cdParam);
      setCdDynamicList(newSelecteds);
      setSelectedItemsData(newSelectedData);
    }
  };

  const addSelectedItem = (itemData) => {
    const productId = itemData.cdProduct || itemData.id || itemData.cdPricebannerThemesList;
    const isAlreadySelected = cdDynamicList.includes(productId);
    if (!isAlreadySelected) {
      setCdDynamicList([...cdDynamicList, productId]);
      setSelectedItemsData([...selectedItemsData, itemData]);
    }
  };


  const buildLastTriedPayload = (metadata, file) => ({
    metadata,
    file,
    validProducts: metadata.productLms || [],
    extractedProducts: metadata.productLms || [],
    validProductsWithDescriptions: metadata.productDescriptions || {},
    showValidationResults: true,
    validationComplete: true
  });



  const getBranchesFromAddMetadata = (metadata) => {
    if (Array.isArray(metadata?.idBranchesFromFile) && metadata.idBranchesFromFile.length > 0) {
      return metadata.idBranchesFromFile;
    }
    const fromMap = Object.values(metadata?.productBranchesByLm || {}).flat();
    return [...new Set(fromMap)];
  };

  /** @returns {'warning'|'error'|null} */
  const processAddProductsValidationResult = (result, selectedBranches) => {
    const invalidStores = result?.invalidStores || result?.data || [];

    if (!Array.isArray(invalidStores) || invalidStores.length === 0) {
      return null;
    }

    const buildWarningMessage = (validCount, invalidCount) => {
      const successKey = 'price.banner.theme.success';
      const integrationKey = validCount === 1
        ? 'price.banner.theme.warning.integration.singular'
        : 'price.banner.theme.warning.integration.plural';
      const detailsKey = invalidCount === 1
        ? 'price.banner.theme.warning.details.singular'
        : 'price.banner.theme.warning.details.plural';
      const successMsg = `<div class="price-banner-warning-success-message"><strong class="price-banner-warning-success-title">${translate(successKey)}</strong></div>`;
      const warningMsg = `${successMsg}<div class="price-banner-warning-message">${translate(integrationKey)}</div>`;
      return warningMsg + translate(detailsKey).replace('{details}', '').trim();
    };

    const invalidCount = invalidStores.length;
    const allInvalid = invalidCount === selectedBranches.length;

    if (allInvalid) {
      setThemeWarningMessage(translate(
        invalidCount === 1
          ? 'price.banner.theme.error.total.singular'
          : 'price.banner.theme.error.total.plural'
      ));
      setThemeWarningType('error');
      setThemeWarningScrollableList([]);
      setShowThemeWarningModal(true);
      return 'error';
    }

    const validCount = selectedBranches.length - invalidCount;
    setThemeWarningMessage(buildWarningMessage(validCount, invalidCount));
    setThemeWarningType('warning');

    const formattedStores = invalidStores.map((store) => {
      const branchId = store.branchId || store.branch_id || '';
      const branchName = store.branchName || store.branch_name || '';
      return `${branchId.padStart(4, '0')} - ${branchName}`;
    });

    setThemeWarningScrollableList(formattedStores);
    setShowThemeWarningModal(true);
    return 'warning';
  };

  const finalizeAddProductsSuccess = () => {
    forceCloseRef.current = true;
    setOpenAddProductModal(false);
    setLastTriedPayload(null);
    setSuccessMessage('Produtos adicionados à lista com sucesso!');
    setOpenSuccessModal(true);
  };

  const handleAddProduct = async (metadata, file) => {
    const payload = buildLastTriedPayload(metadata, file);
    setLastTriedPayload(payload);

    try {
      const response = await addProductsToList(dsToken, metadata.listId, metadata);

      const isSuccess = response && (
        response.success === true ||
        response.cdStatus === 200 ||
        response.cdStatus === 201
      );
      if (isSuccess) {
        const selectedBranches = getBranchesFromAddMetadata(metadata);
        const invalidStores = response?.invalidStores || [];
        const themeValidation = selectedBranches.length > 0
          ? processAddProductsValidationResult({ invalidStores }, selectedBranches)
          : null;

        if (themeValidation) {
          setPendingAddSuccess(themeValidation === 'warning');
          return;
        }

        finalizeAddProductsSuccess();
      } else {
        throw new Error(response?.message || 'Erro desconhecido ao adicionar produtos');
      }
    } catch (error) {
      const status = error?.cdStatus;
      const normalizedError = status === 409 ? normalizeConflictProductError(error) : error;
      const conflictingLms = normalizedError?.conflictingLms || [];
      const productLms = normalizedError?.productLms || [];

      if (status === 409 && Array.isArray(conflictingLms) && conflictingLms.length > 0) {
        setInvalidProducts(conflictingLms);
        const attemptedProductLms = productLms.length > 0 ? productLms : payload.metadata?.productLms || [];
        setLastTriedPayload({
          ...payload,
          productLms: attemptedProductLms,
          attemptedProductLms
        });
        setShowProductsWarningModal(true);
        return;
      }

      if (status === 409) {
        const listId = metadata.listId || '---';
        const message = `Erro ao adicionar produtos à lista ${listId}`;
        setErrorDetails(message);
        setLastTriedPayload({
          metadata,
          file,
          validProducts: metadata.productLms || [],
          extractedProducts: metadata.productLms || [],
          validProductsWithDescriptions: metadata.productDescriptions || {},
          showValidationResults: true,
          validationComplete: true
        });
        setOpenWarningModal(true);
        return;
      }

      let errorMessage = error?.dsMessage || error?.message || translate('price.banner.error.generic');
      if (typeof errorMessage === 'object') {
        errorMessage = JSON.stringify(errorMessage);
      } else if (typeof errorMessage !== 'string') {
        errorMessage = String(errorMessage);
      }

      if (errorMessage === 'Failed to fetch') {
        errorMessage = translate('price.banner.error.details');
      }
      setErrorDetails(errorMessage);
      setLastTriedPayload({
        metadata,
        file,
        validProducts: metadata.productLms || [],
        extractedProducts: metadata.productLms || [],
        validProductsWithDescriptions: metadata.productDescriptions || {},
        showValidationResults: true,
        validationComplete: true
      });
      setFailedOperation('CREATE');
      setOpenErrorModal(true);
    }
  }

  const handleModalClose = () => {
    setOpenSuccessModal(false)
    const param = {
      ...DEFAULT_PAGINATION,
      ...filters,
      ...order,
      size: optionSize,
      idBranches: filters.idBranchesCodes ?? filters.idBranches ?? [],
    };
    delete param.idBranchesCodes;
    find(dsToken, cleanParam(param));
  }

  const handleAddProductModalOpenChange = (isOpen) => {
    if (isOpen) {
      forceCloseRef.current = false;
      setOpenAddProductModal(true);
      return;
    }
    if (!forceCloseRef.current) {
      setShowConfirmExitModal(true);
      return;
    }
    setOpenAddProductModal(false);
    setLastTriedPayload(null);
    forceCloseRef.current = false;
  };

  const renderAddProductModal = () => {
    if (!openAddProductModal) return

    const { listId } = extractUrlParams()

    let listName = null;
    if (listId && list && Array.isArray(list)) {
      const foundList = list.find(item =>
        String(item.idPriceBannerList) === String(listId) ||
        String(item.cdPricebannerThemesList) === String(listId)
      );
      if (foundList) {
        listName = foundList.name || foundList.nameList;
      }
    }

    const isRetryMode = !!lastTriedPayload;
    return (
      <AddProductModal
        title={translate('price.banner.addproductslist')}
        open={openAddProductModal}
        onOpenChange={handleAddProductModalOpenChange}
        onSave={handleAddProduct}
        initialData={lastTriedPayload?.metadata ? {
          ...lastTriedPayload.metadata,
          file: lastTriedPayload.file,
          validProducts: lastTriedPayload.validProducts,
          invalidProducts: lastTriedPayload.invalidProducts,
          extractedProducts: lastTriedPayload.extractedProducts,
          validProductsWithDescriptions: lastTriedPayload.validProductsWithDescriptions,
          showValidationResults: lastTriedPayload.showValidationResults,
          validationComplete: lastTriedPayload.validationComplete
        } : lastTriedPayload}
        translate={translate}
        user={auth.user}
        validateProducts={validateProducts}
        validateBranches={validateBranches}
        cancelValidation={cancelValidation}
        listName={listName}
        isRetryMode={isRetryMode}
      />
    )
  }

  const renderSuccessModal = () => {
    if (!openSuccessModal) return

    return (
      <SuccessModal
        fillButton
        center
        handleClose={handleModalClose}
        size='lg'
        buttonText={translate('ok_button')}
        msg={successMessage || translate('parameters.success.msg')}
        t={translate}
      />
    )
  }

  const handleRetry = () => {
    setOpenErrorModal(false);

    switch (failedOperation) {
      case 'CREATE':
        break;
      case 'DELETE':
        if (failedDeleteData) {
          setOpenDeleteModal({ show: true, selected: failedDeleteData, isProductDeletion: true });
        }
        break;
      default:
        break;
    }

    if (failedOperation === 'DELETE') {
      setFailedOperation(null);
      setFailedDeleteData(null);
    } else {
      setFailedOperation(null);
    }
  };

  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
    forceCloseRef.current = true;

    switch (failedOperation) {
      case 'CREATE':
        setOpenAddProductModal(false);
        setLastTriedPayload(null);
        break;
      case 'DELETE':
        setFailedDeleteData(null);
        break;
      default:
        break;
    }

    setFailedOperation(null);

    setTimeout(() => {
      forceCloseRef.current = false;
    }, 10);
  };
  const renderErrorModal = () => {
    if (!openErrorModal) return null;

    return (
      <PricebannerErrorModal
        onConfirm={handleRetry}
        onClose={handleCloseErrorModal}
        text={translate('price.banner.error.generic')}
        title={'Ops!'}
        details={translate('price.banner.error.details')}
        okButton={translate('newLogin.errorModal.button.label')}
        translate={translate}
      />
    );
  };

  const handleRetryWarning = () => {
    setOpenWarningModal(false);
    forceCloseRef.current = true;
    setOpenAddProductModal(true);
  };

  const handleCloseWarningModal = () => {
    setOpenWarningModal(false);
    setLastTriedPayload(null);
    forceCloseRef.current = false;
  };

  const renderWarningModal = () => {
    if (!openWarningModal) return null;

    return (
      <PricebannerWarningModal
        onNewRegister={handleRetryWarning}
        onClose={handleCloseWarningModal}
        details={errorDetails}
        isOpen={true}
        translate={translate}
      />
    );
  };

  const handleSeeInvalidProducts = () => {
    setShowProductsWarningModal(false);
    setOpenAddProductModal(false);

    try {
      if (filters) {
        sessionStorage.setItem('priceBannerProductFilters', JSON.stringify(filters));
      }
    } catch (error) {
      // Ignore session storage errors
    }

    const urlParams = extractUrlParams();
    const productLms = invalidProducts || [];
    const metadata = lastTriedPayload?.metadata;

    const newParams = {};

    if (metadata?.idBranches && metadata.idBranches.length > 0) {
      newParams.idBranches = metadata.idBranches;
    } else if (urlParams.idBranches && urlParams.idBranches.length > 0) {
      newParams.idBranches = urlParams.idBranches;
    }

    if (metadata?.dtStart) {
      newParams.dtStart = moment(metadata.dtStart).isValid()
        ? moment(metadata.dtStart).format('YYYY-MM-DD')
        : metadata.dtStart;
    } else if (urlParams.dtStart) {
      newParams.dtStart = urlParams.dtStart;
    }

    if (metadata?.dtEnd) {
      newParams.dtEnd = moment(metadata.dtEnd).isValid()
        ? moment(metadata.dtEnd).format('YYYY-MM-DD')
        : metadata.dtEnd;
    } else if (urlParams.dtEnd) {
      newParams.dtEnd = urlParams.dtEnd;
    }

    const newFilters = {
      ...DEFAULT_INITIAL_VALUES,
      ...newParams,
      productLms: productLms.length > 0 ? productLms : undefined
    };

    setFilters(newFilters);
    setShowTable(true);

    updateUrlWithParams(newParams);

    if (productLms.length > 0) {
      const param = {
        ...newFilters,
        ...DEFAULT_PAGINATION,
        ...order,
        size: optionSize,
        idBranches: newFilters.idBranchesCodes ?? newFilters.idBranches ?? [],
      };
      delete param.idBranchesCodes;
      find(dsToken, cleanParam(param));
    }

    setInvalidProducts([]);
    setLastTriedPayload(null);
  };

  const handleContinueWithoutInvalidProducts = async () => {
    setShowProductsWarningModal(false);

    try {
      const payload = lastTriedPayload?.metadata;
      if (!payload) {
        return;
      }

      const invalidProductLms = new Set(invalidProducts);
      const filteredProductLms = (payload.productLms || []).filter(lm => !invalidProductLms.has(lm));
      const filteredProductDescriptions = { ...payload.productDescriptions };
      invalidProductLms.forEach(lm => {
        delete filteredProductDescriptions[lm];
      });

      let updatedMetadata = {
        ...payload,
        productLms: filteredProductLms,
        productDescriptions: filteredProductDescriptions
      };

      const branchFiltered = filterBranchMapsForProductLms(
        {
          productBranchesByLm: payload.productBranchesByLm,
          productBranchExtrasByLm: payload.productBranchExtrasByLm,
          productExtrasByLm: payload.productExtrasByLm,
        },
        filteredProductLms
      );

      updatedMetadata = {
        ...updatedMetadata,
        ...branchFiltered,
      };

      const branchSet = new Set();
      Object.values(branchFiltered.productBranchesByLm || {}).forEach((branches) => {
        branches.forEach((b) => branchSet.add(b));
      });
      if (branchSet.size > 0) {
        updatedMetadata.idBranchesFromFile = [...branchSet];
      } else {
        delete updatedMetadata.idBranchesFromFile;
      }

      await handleAddProduct(updatedMetadata, lastTriedPayload?.file);
      setInvalidProducts([]);
    } catch (error) {
      // Error handling is done in handleAddProduct
    }
  };

  const renderProductsWarningModal = () => {
    if (!showProductsWarningModal) return null;

    const totalProducts = lastTriedPayload?.attemptedProductLms?.length ||
      lastTriedPayload?.productLms?.length ||
      lastTriedPayload?.metadata?.productLms?.length ||
      lastTriedPayload?.validProducts?.length || 0;
    const allInvalid = totalProducts > 0 && invalidProducts.length === totalProducts;

    if (allInvalid) {
      return (
        <DetailedWarningModal
          translate={translate}
          title={translate('attention')}
          message={translate('price.banner.product.error.total')}
          onClose={() => {
            setShowProductsWarningModal(false);
            setInvalidProducts([]);
          }}
          isError={true}
          showButton1={true}
          button1Text={translate('position.register.edit')}
          onButton1Click={() => {
            setShowProductsWarningModal(false);
            setInvalidProducts([]);
          }}
          button2Text={translate('price.banner.product.see.lms')}
          onButton2Click={handleSeeInvalidProducts}
          singleButtonCenter={false}
        />
      );
    }

    return (
      <DetailedWarningModal
        translate={translate}
        title={translate('attention')}
        message={translate(invalidProducts.length === 1 ? 'price.banner.product.warning.singular' : 'price.banner.product.warning.plural')}
        onClose={() => {
          setShowProductsWarningModal(false);
          setInvalidProducts([]);
        }}
        isError={false}
        showButton1={true}
        button1Text={translate('price.banner.product.see.lms')}
        onButton1Click={handleSeeInvalidProducts}
        button2Text={translate('price.banner.product.continue')}
        onButton2Click={handleContinueWithoutInvalidProducts}
        scrollableList={invalidProducts}
      />
    );
  };

  const handleConfirmExit = () => {
    setShowConfirmExitModal(false);
    forceCloseRef.current = true;

    if (cancelValidation) {
      cancelValidation();
    }

    if (openAddProductModal) {
      setOpenAddProductModal(false);
      setLastTriedPayload(null);
    }
    setTimeout(() => {
      forceCloseRef.current = false;
    }, 10);
  };

  const renderThemeWarningModal = () => {
    if (!showThemeWarningModal) return null;

    return (
      <DetailedWarningModal
        translate={translate}
        message={themeWarningMessage}
        messageAsHtml={themeWarningMessage}
        onClose={() => {
          setShowThemeWarningModal(false);
          setThemeWarningMessage('');
          setThemeWarningScrollableList(null);
          if (pendingAddSuccess) {
            setPendingAddSuccess(false);
            finalizeAddProductsSuccess();
          }
        }}
        isError={themeWarningType === 'error'}
        showButton1={false}
        scrollableList={themeWarningScrollableList}
        singleButtonCenter
      />
    );
  };

  const renderConfirmExitModal = () => {
    if (
      !showConfirmExitModal ||
      openErrorModal ||
      openWarningModal ||
      openSuccessModal ||
      showThemeWarningModal
    ) {
      return null;
    }

    return (
      <PricebannerConfirmExitModal
        isOpen={showConfirmExitModal}
        onClose={() => setShowConfirmExitModal(false)}
        onConfirm={handleConfirmExit}
        translate={translate}
      />
    );
  };
  const handleOpenDeleteModal = (selectedIds) => {
    const selectedObjects = selectedIds
      .map(id => {
        const storedItem = selectedItemsData.find(item => item.cdProduct === id);
        if (storedItem) return storedItem;

        return displayProducts.find(item => item.cdProduct === id);
      })
      .filter(Boolean);
    const hasProductIds = selectedObjects.some(obj => obj.productId);

    setOpenDeleteModal({
      show: true,
      selected: selectedObjects,
      isProductDeletion: hasProductIds
    });
  };

  const handleConfirmDelete = async (id) => {
    if (!id) return;

    try {
      const originalId = id.includes('_') ? id.split('_')[0] : id;
      const productRecord = displayProducts.find(p => p.cdProduct === id);

      if (productRecord && productRecord.productId) {
        try {
          await deleteProductFromList(dsToken, originalId, productRecord.productId);
          setSuccessMessage('Produto removido da lista com sucesso!');
          setOpenSuccessModal(true);
        } catch (error) {
          let errorMessage = error?.message || translate('price.banner.error.generic');
          if (errorMessage === 'Failed to fetch') {
            errorMessage = translate('price.banner.error.details');
          }
          setErrorDetails(errorMessage);
          setFailedOperation('DELETE');
          const failedItem = displayProducts.find(item => item.cdProduct === id);
          setFailedDeleteData(failedItem ? [failedItem] : null);
          setOpenErrorModal(true);
        }
      }
    } catch (error) {
      let errorMessage = error?.message || translate('price.banner.error.generic');
      if (errorMessage === 'Failed to fetch') {
        errorMessage = translate('price.banner.error.details');
      }
      setErrorDetails(errorMessage);
      setFailedOperation('DELETE');
      const failedItem = displayProducts.find(item => item.cdProduct === id);
      setFailedDeleteData(failedItem ? [failedItem] : null);
      setOpenErrorModal(true);
    }
  };

  const renderDeleteModal = () => {
    if (!openDeleteModal.show) return null;

    const selectedItems = openDeleteModal.selected || [];
    const { isProductDeletion } = openDeleteModal;
    const isSingle = selectedItems.length === 1;
    const dynamicName = null;

    const message = () => {
      if (isSingle) {
        if (isProductDeletion) {
          return (
            <div style={{ textAlign: 'center' }}>
              <p style={{ fontSize: '18px' }}>{translate('price.banner.products.delete.message.singular')}</p>
              <p style={{ fontSize: '14px' }}>
                <strong>Produto:</strong><br />{selectedItems[0].description}
              </p>
            </div>
          );
        }
        return null;
      }
      if (isProductDeletion) {
        return (
          <div className='delete-multi-dynamics'>
            <p style={{ fontSize: '18px' }}>
              Você selecionou {selectedItems.length} produtos. <br /> Deseja remover estes produtos das listas correspondentes?
            </p>
            <p style={{ fontSize: '16px', marginTop: '1rem', fontWeight: 'bold' }}>{selectedItems.length === 1 ? 'Produto:' : 'Produtos:'}</p>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {selectedItems.map((item, index) => (
                <li key={index}>{item.description || item.lm}</li>
              ))}
            </ul>
          </div>
        );
      }

      return (
        <div className='delete-multi-dynamics'>
          <p style={{ fontSize: '18px' }}>
            Você selecionou {selectedItems.length} itens de produtos. <br /> Deseja excluir as listas correspondentes definitivamente do sistema?
          </p>
          <p style={{ fontSize: '16px', marginTop: '1rem', fontWeight: 'bold' }}>Listas:</p>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {selectedItems.map((item, index) => (
              <li key={index}>{item.description}</li>
            ))}
          </ul>
        </div>
      );
    };

    const handleConfirmDeleteMultiple = async (selectedItems) => {
      setOpenDeleteModal({ show: false, selected: null });
      if (isProductDeletion) {
        try {
          const deletePromises = selectedItems.map(async (item) => {
            const originalId = item.cdProduct.includes('_') ? item.cdProduct.split('_')[0] : item.cdProduct;
            if (item.productId) {
              return deleteProductFromList(dsToken, originalId, item.productId);
            }
            return null;
          });

          await Promise.all(deletePromises.filter(Boolean));
          const message = selectedItems.length === 1
            ? 'Produto removido da lista com sucesso!'
            : 'Produtos removidos das listas com sucesso!';
          setSuccessMessage(message);
          setOpenSuccessModal(true);
        } catch (error) {
          let errorMessage = error?.message || translate('price.banner.error.generic');
          if (errorMessage === 'Failed to fetch') {
            errorMessage = translate('price.banner.error.details');
          }
          setErrorDetails(errorMessage);
          setFailedOperation('DELETE');
          setFailedDeleteData(selectedItems);
          setOpenErrorModal(true);
        }
      }
      setCdDynamicList([]);
      setSelectedItemsData([]);
    };

    return (
      <ExclusionModalPriceBanner
        isOpen={true}
        useControlledState={true}
        onClose={() => setOpenDeleteModal({ show: false, selected: null })}
        t={translate}
        title={isProductDeletion ? translate("price.banner.products.delete.plural") : translate("price.banner.lists.delete.plural")}
        message={message}
        dynamicName={dynamicName}
        onConfirm={() => handleConfirmDeleteMultiple(selectedItems)}
        confirmButtonMsg={isProductDeletion ? "Sim, remover" : translate('missionMenu.removeModal.ok')}
        cancelButtonMsg={translate('cancel_button')}
        size="sm"
        renderButton={null}
        customDeleteMessageSingular={isProductDeletion ? translate('price.banner.products.delete.message.singular') : translate('price.banner.lists.delete.message.singular')}
        customDeleteMessagePlural={isProductDeletion ? translate('price.banner.products.delete.message.plural') : translate('price.banner.lists.delete.message.plural')}
        customDynamicLabel={isProductDeletion ? translate('price.banner.delete.product.label') : translate('price.banner.lists.label')}
        itemCount={selectedItems.length}
      />
    );
  };
  const handleOrder = (order, orderDirection) => {
    const param = {
      ...filters,
      ...pagination,
      order,
      orderDirection
    }

    setOrder({ order, orderDirection })
    if (showTable) {
      find(dsToken, cleanParam(param))
    }
  }

  const renderNewPagination = () => {
    const PAGINATION_OPTIONS = [
      { label: '5', value: 5 },
      { label: '10', value: 10 },
      { label: '20', value: 20 },
      { label: '30', value: 30 },
      { label: '40', value: 40 },
    ]

    const countItems = () => {
      if (metadata.page === 1) return 1;
      return ((metadata.page - 1) * metadata.perPage) + 1;
    };
    const DropdownIndicator = props => (
      <components.DropdownIndicator {...props}>
        <DropdownArrow />
      </components.DropdownIndicator>
    )

    if (!(displayProducts ?? []).length) return
    return (
      <Row className="new-relatory-row stock-transfer-pagination" >
        <Col className="align-center margin-bottom ">
          <NewPagination
            navClass='pagination new-relatory'
            count={metadata.totalCount}
            current={metadata.page}
            getPage={(page) => {
              setPagination({ ...pagination, size: optionSize, page })
            }}
            pages={metadata.pageCount}
          />
          <div className='datasheet-manager-pagination-size-selector show-pages-new-relatory'>
            <Col className="show-per-page-text" xs={7}>{translate('pagination.size.selector')}</Col>
            <Col xs={4}>
              <SizeSelect
                components={{ DropdownIndicator }}
                isSearchable={false}
                styles={colourStyles}
                classNamePrefix='react-select'
                onChange={(option) => {
                  setOptionSize(option.value)
                  setPagination({ ...pagination, page: 1, size: option.value })
                }}
                options={PAGINATION_OPTIONS}
                value={PAGINATION_OPTIONS.find((i) => i.value === optionSize)}
                menuPlacement='top'
              />
            </Col>
          </div>
          <div style={{ float: 'left' }} className='datasheet-manager-pagination-size-selector show-items-new-relatory'>
            <Col >{`
            ${translate('pagination.size.show')}
            ${countItems()} - ${metadata.page * metadata.perPage > metadata.totalCount
                ? metadata.totalCount
                : metadata.page * metadata.perPage}
            ${translate("pagination.size.of")}
            ${metadata.totalCount}
            ${translate("pagination.size.items")}`}
            </Col>
          </div>
        </Col>
      </Row>
    )
  }

  const isDefaultFilter = () => {
    if (!filters) return true;

    const hasBranches = (filters.idBranches?.length ?? 0) > 0;
    const hasStatus = filters.status != null && filters.status !== '';
    const hasName = filters.name && filters.name !== "Todos";
    const hasTheme = filters.themeCode && filters.themeCode !== "todos";
    const hasList = filters.listId && filters.listId !== "todos";
    const hasProducts = (filters.productLms?.length ?? 0) > 0;

    return !(hasBranches || hasStatus || hasName || hasTheme || hasList || hasProducts);
  };

  const inActionMode = cdDynamicList.length > 0
  const hasData = (displayProducts ?? []).length > 0;
  const isDownloadDisabled = isDownloading || !hasData;
  const defaultFilter = isDefaultFilter();

  const hasListIdandDtStart = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('listId') !== null || urlParams.get('dtStart') !== null;
  };

  const handleGoBack = () => {
    try {
      const savedFilters = sessionStorage.getItem('priceBannerProductFilters');
      if (savedFilters) {
        const restoredFilters = JSON.parse(savedFilters);
        sessionStorage.removeItem('priceBannerProductFilters');
        sessionStorage.removeItem('priceBannerPreviousUrl');

        setFilters(restoredFilters);
        setShowTable(true);

        const param = {
          ...restoredFilters,
          ...DEFAULT_PAGINATION,
          ...order,
          size: optionSize,
          idBranches: restoredFilters.idBranchesCodes ?? restoredFilters.idBranches ?? [],
        };
        delete param.idBranchesCodes;
        find(dsToken, cleanParam(param));
        return;
      }
    } catch (error) {
      // Ignore session storage errors
    }

    const previousUrl = sessionStorage.getItem('priceBannerPreviousUrl');
    if (previousUrl) {
      sessionStorage.removeItem('priceBannerPreviousUrl');
      browserHistory.push(previousUrl);
    } else {
      browserHistory.push('/pricebanner/list-themes');
    }
  };

  const handleLoadProducts = () => {
    if (!filters) return;

    const param = {
      ...filters,
      ...pagination,
      ...order,
      page: pagination.page,
      size: optionSize,
      idBranches: filters.idBranchesCodes ?? filters.idBranches ?? [],
    };

    delete param.idBranchesCodes;
    find(dsToken, cleanParam(param));
  };

  const handleEditExtrasSuccess = () => {
    setSuccessMessage('Informações complementares atualizadas com sucesso!');
    pendingEditExtrasSuccessRef.current = true;
    /* Não chama handleLoadProducts() aqui: o overlay "Carregando as informações" ficaria
       visível junto com o modal de sucesso. A lista é recarregada ao fechar o modal de sucesso (handleModalClose). */
  };

  const handleEditExtrasModalClosed = () => {
    if (pendingEditExtrasSuccessRef.current) {
      pendingEditExtrasSuccessRef.current = false;
      // Só abre o modal de sucesso depois do modal de edição ter saído da tela,
      // para que nada do sucesso apareça durante o carregamento
      requestAnimationFrame(() => {
        requestAnimationFrame(() => setOpenSuccessModal(true));
      });
    }
  };

  return (
    <div className='stock-adjustment pricebanner-themes.list'>
      <div ref={headerRef} className='stock-adjustment-header'>
        <ContentHeader>{translate('price.banner.products')}</ContentHeader>
      </div>
      {inlineFilterVisible && (
        <div className='content-filter'>
          <InlineFilterProduct
            inlineFilterVisible={inlineFilterVisible}
            submit={setValues}
            translate={translate}
            closeFilters={() => setInlineFilterVisible(false)}
            resetFilters={resetFilters}
            user={auth.user}
          />
        </div>
      )}

      {!inlineFilterVisible && (
        <div className='content-main'>
          <div ref={filterRef}
            className={`padding-bottom header-mission-block ${cdDynamicList.length === 0 ? 'pricebanner-margin-top' : ''}`}
          >
            <DynamicsSelector
              dynamicsSelected={cdDynamicList}
              cdDynamicList={cdDynamicList.length}
              handleSideFilterMenuCollapseChange={setSideFilterVisible}
              setCdDynamicList={setCdDynamicList}
              setRemoveModal={handleOpenDeleteModal}
              sideFilterVisible={sideFilterVisible}
              translate={translate}
              customQuantityPlural={translate('dynamic.selection.quantityPlural.products')}
              customQuantitySingular={translate('dynamic.selection.quantitySingular.products')}
              customRemovePlural={translate('dynamic.selection.removePlural.products')}
              customRemoveSingular={translate('dynamic.selection.removeSingular.products')}
              customCancelText={translate('dynamic.selection.cancelPlural')}
            />
          </div>

          {!inActionMode && (
            <div ref={filterRef} className='spacing-end' style={{ marginLeft: '20px' }}>
              <div style={{ marginRight: 'auto' }}>
                {hasListIdandDtStart() && (
                  <button
                    className='btn geral-vision'
                    onClick={handleGoBack}
                  >
                    <OneArrowLeft />
                    {translate('confirmModal.back_button')}
                  </button>
                )}
              </div>

              {/* Botão para baixar o relatório */}
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <button
                  type="button"
                  style={{ marginRight: '24px', background: "#41A017", borderRadius: '8px', height: '44px', color: "#fff" }}
                  className='btn filter-mission-block pricebanner-download-report-btn'
                  onClick={handleDownloadReport}
                  disabled={isDownloadDisabled}
                >
                  <DownloadSVG className="common-download"
                    style={{ position: 'relative', top: '1px' }} />
                  {translate('price.banner.downloadreport')}

                </button>

                {/* Botão para adicionar produtos em lista */}
                <button
                  style={{ marginRight: '24px', background: "#41A017", borderRadius: '8px', height: '44px', color: "#fff" }}
                  className='btn filter-mission-block' onClick={() => setOpenAddProductModal(true)}
                >
                  {translate('price.banner.addproductslist')}
                </button>

                {/* Botão de filtros */}
                <button style={{ marginRight: '24px' }} className='btn filter-mission-block' onClick={() => setSideFilterVisible(true)}>
                  <FilterSVG newDesign={false} className="common-download" />
                  <span>{translate('commonReport.filters')}</span>
                </button>
              </div>
            </div>
          )}

          <div
            style={{ margin: '0 !important' }}
            ref={tableRef}
            className='stock-adjustment-table new'
          >

            <div style={{ boxShadow: (displayProducts ?? []).length < 1 && 'none' }} className='outer-table stock-transfer-outer-table'>
              <div className='flex'>
                <SideFilterProduct
                  user={auth.user}
                  resetFilters={resetFilters}
                  closeFilters={closeFilter}
                  handleSideFilterElementChange={setSideFilterElement}
                  initialValues={DEFAULT_INITIAL_VALUES}
                  sideFilterVisible={sideFilterVisible}
                  submit={setValues}
                  translate={translate}
                  currentFilters={filters}
                  listsData={list}
                />
                {showTable ? (
                  hasData ? (
                    <TableProduct
                      emptyFilter={emptyFilter}
                      removeSelected={removeSelected}
                      addSelectedItem={addSelectedItem}
                      cdDynamicList={cdDynamicList}
                      handleOrder={handleOrder}
                      handleResize={handleResize}
                      handleConfirmDelete={handleConfirmDelete}
                      records={displayProducts}
                      setCdDynamicList={setCdDynamicList}
                      setSelectedItemsData={setSelectedItemsData}
                      translate={translate}
                      user={auth.user}
                      onRefresh={handleLoadProducts}
                      onEditExtrasSuccess={handleEditExtrasSuccess}
                      onEditExtrasModalClosed={handleEditExtrasModalClosed}
                    />
                  ) : defaultFilter ? (
                    <div
                      style={{ width: '100%', height: '500px', margin: '0px' }}
                      className='relatory-no-data pictogram-empty no-register'
                    >
                      <p className="no-register-title">{translate('price.banner.no.lists.registered')}</p>
                      <p className="no-register-subtitle">{translate('price.banner.start.registration.adding.lists')}</p>
                    </div>
                  ) : (
                    <div
                      style={{ width: '100%', height: '500px', margin: '0px' }}
                      className='relatory-no-data pictogram-empty'
                    >
                      <p style={{ fontSize: '24px' }}>{translate('no.results')}</p>
                      <p className='no-result-filter'>{translate('no.results.please')}</p>
                    </div>
                  )
                ) : (
                  <div
                    style={{ width: '100%', height: '500px', margin: '0px' }}
                    className='relatory-no-data pictogram-empty no-register'
                  >
                    <p className="no-register-title">{translate('price.banner.apply.filters.to.start')}</p>
                    <p className="no-register-subtitle">{translate('price.banner.use.filters.to.search.products')}</p>
                  </div>
                )}
              </div>
              {renderNewPagination()}
            </div>

          </div>
          {renderAddProductModal()}
          {renderSuccessModal()}
          {renderErrorModal()}
          {renderWarningModal()}
          {renderProductsWarningModal()}
          {renderThemeWarningModal()}
          {renderConfirmExitModal()}
          {renderDeleteModal()}
        </div>
      )}
    </div>

  )
}
PriceBannerProductContainer.propTypes = {
  auth: PropTypes.object.isRequired,
  find: PropTypes.func.isRequired,
  deleteProductFromList: PropTypes.func.isRequired,
  addProductsToList: PropTypes.func.isRequired,
  clearPriceBannerList: PropTypes.func.isRequired,

  validateProducts: PropTypes.func.isRequired,
  validateBranches: PropTypes.func.isRequired,
  cancelValidation: PropTypes.func,
  downloadProductsReport: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  list: PropTypes.array,
  metadata: PropTypes.object
}

const mapStateToProps = (state) => ({
  list: state.pricebannerListReducer?.list ?? [],
  metadata: state.pricebannerListReducer?.metadata ?? {},
  auth: state.auth,
});
const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    find: pricebannerListActions.find,
    deleteProductFromList: pricebannerListActions.deleteProductFromList,
    addProductsToList: pricebannerListActions.addProductsToList,
    clearPriceBannerList: pricebannerListActions.clearPriceBannerList,

    validateProducts: pricebannerListActions.validateProducts,
    validateBranches: pricebannerListActions.validateBranches,
    cancelValidation: pricebannerListActions.cancelValidation,
    downloadProductsReport: pricebannerListActions.downloadProductsReport,
  },
  dispatch
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(
    PriceBannerProductContainer
  )
)

export { PriceBannerProductContainer }
